<h2 mat-dialog-title *transloco="let t">
    {{ t('auth.consentGateTitle') }}
</h2>
<div mat-dialog-content *transloco="let t" class="flex flex-col gap-3">
    <p>{{ t('auth.consentGateBody') }}</p>

    <form [formGroup]="form" class="flex flex-col gap-1">
        <mat-checkbox formControlName="terms">
            {{ t('auth.acceptTermsPre') }}
            <a
                [href]="marketingBase + '/terms'"
                target="_blank"
                rel="noopener noreferrer"
                class="underline underline-offset-2 hover:text-foreground"
                >{{ t('auth.termsOfService') }}</a
            >
            {{ t('auth.acceptTermsMid') }}
            <a
                [href]="marketingBase + '/privacy'"
                target="_blank"
                rel="noopener noreferrer"
                class="underline underline-offset-2 hover:text-foreground"
                >{{ t('auth.privacyPolicy') }}</a
            >
            {{ t('auth.acceptTermsPost') }}
        </mat-checkbox>
        <mat-checkbox formControlName="aiProcessing">
            {{ t('auth.acceptAiPre') }}
            <a
                [href]="marketingBase + '/privacy'"
                target="_blank"
                rel="noopener noreferrer"
                class="underline underline-offset-2 hover:text-foreground"
                >{{ t('auth.privacyPolicy') }}</a
            >
            {{ t('auth.acceptAiPost') }}
        </mat-checkbox>
    </form>

    @if (failed) {
        <p class="text-red-600" data-testid="consent-gate-error">
            {{ t('auth.consentGateError') }}
        </p>
    }
</div>
<div mat-dialog-actions align="end" *transloco="let t">
    <button
        mat-flat-button
        color="primary"
        [disabled]="form.invalid || accepting"
        (click)="accept()"
    >
        @if (accepting) {
            <mat-progress-spinner
                [diameter]="16"
                mode="indeterminate"
                class="inline-block"
            ></mat-progress-spinner>
        }
        {{ t('auth.consentGateCta') }}
    </button>
</div>
